<template>
    <div class="pt-8">
        <template >
            <b-card no-body >
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="info">
                        <b-icon icon="search" aria-hidden="true"></b-icon>
                        Filtro de busqueda
                    </b-button>
                </b-card-header>
                <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text>
                            <b-row>        
                                <b-col cols="12" md="4">
                                    <label for="date-from">Desde</label>
                                    <b-form-datepicker placeholder="Seleccione Desde" id="date-from" v-model="dateFrom"></b-form-datepicker>
                                </b-col>
                                <b-col cols="12" md="4">
                                    <label for="date-to">Hasta</label>
                                    <b-form-datepicker id="date-to" v-model="dateTo"></b-form-datepicker>
                                </b-col>
                                <b-col cols="12" md="12">
                                    <div >
                                        <b-button variant="info" @click.prevent="getVentas" class="mx-1">
                                            <b-icon icon="search" aria-hidden="true"></b-icon>
                                            Buscar
                                        </b-button>
                                        <b-button variant="warning" @click.prevent="clearSearchForm" class="mx-1 text-white">
                                            <b-icon icon="backspace" aria-hidden="true"></b-icon>
                                            Limpiar
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>
        </template>
        <b-card header-tag="header" footer-tag="footer" class="mt-8">
            <template v-slot:header>
                <p class="mb-0" style="font-size: 21px">Ventas Totales</p>
            </template>
           <b-row>          
                <b-col cols="12" md="12">
                    <div >
                        <b-button variant="info" class="text-white" :to="{name: 'ListadoVentas'}">Listado de Ventas</b-button>
                    </div>
                </b-col>
            </b-row>
            <b-card-text>
                <b-table 
                    responsive
                    :fields="fields" 
                    striped hover 
                    :items="ventas">
                    <template v-slot:cell(date)="data">
                        {{ data.item.date }}
                    </template>
                    <template v-slot:cell(ventas)="data">
                        {{ data.item.ventas }}
                    </template>
                    
                    <template v-slot:cell(monto_total)="data">
                        $ {{numberFormat(data.item.monto_total) }}
                    </template>
                    
                </b-table>
                <template v-if="ventas.length < 1">
                    <b-alert show variant="danger">
                        Lo sentimos, no se han encontrado resultados para su busqueda.
                    </b-alert>
                </template>
            </b-card-text>
        </b-card>
    </div>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
    data(){
        return{
            ventas: [],
            dateFrom: "",
            dateTo: new Date().toISOString().substr(0, 10),
            fields: [
                { key: 'date', label: 'Fecha', sortable: true},
                { key: 'ventas', label: 'Cantidad Ventas', sortable: true},
                { key: 'monto_total', label: 'Mont total', sortable: true},
            ],
        }
    },
    created(){
        this.getVentas();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getVentas() {
            this.pageOptions = { 
                dateFrom:     this.dateFrom,
                dateTo:       this.dateTo,
            }
            this.setLoading(true)
            await this.$conectar.post('punto-venta/get-ventas-totales', this.pageOptions)
            .then(response =>{
                this.ventas = response.data.ventasLists;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getVentas();
        },
        clearSearchForm(){
            this.ventaId = "";
            this.vendedor = "";
            this.cliente = "";
            this.nit = "";
            this.dateFrom = "";
            this.dateTo = new Date().toISOString().substr(0, 10);
        },
    }
}
</script>

<style scoped>
.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}
.singleLineTd td {
  white-space: nowrap !important;
  overflow: hidden !important;
}
</style>